import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'

/** Bottom conversion call-to-action band. */
export function CtaSection() {
  const { t, path } = useI18n()

  return (
    <section className="border-t bg-background py-24">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-4 text-center">
        <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t('ctaTitle')}</h2>
        <p className="mt-4 text-lg text-muted-foreground">{t('ctaSubtitle')}</p>
        <Button asChild size="xl" className="mt-8">
          <Link to={path('/tools/video-converter')}>{t('heroCtaStart')}</Link>
        </Button>
      </div>
    </section>
  )
}